/**
 * Created by pandemio on 9/20/18.
 */
import React from 'react';
import {Col, Card, CardBody, CardHeader, Container, Row} from 'reactstrap';
/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../translations/global.json";
/** End of Multiple Language imports **/

import SelectorProduct from "./selectors/selector-product";
import SelectorLesson from "./selectors/selector-lesson";
import ApiCalls from "../custom-classes/api-calls";
import LanguageManager from '../custom-classes/language-manager';
import NavbarMobile from './navbar/navbar-mobile';
import NavbarDesktop from './navbar/navbar-desktop-top';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faList} from '@fortawesome/free-solid-svg-icons';
import Footer from './footer/footer';

/**
 * The component (window) to update the syllabus
 */
class Syllabus extends React.Component {

    constructor(props) {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });
        this.props.addTranslation(global);

        this.state = {
            syllabusInfo: null,
            productId: null, // The product ID (course)
            navbarMobile: false,
            sessionValid: true
        };
    }

    /**
     * Handle the lessons call
     */
    callLessons = () => (newValue) => {
        this.setState({'productId': newValue,

            syllabusInfo: null});
    };

    /**
     * Call the syllabus data
     */
    callSyllabus = () => (newValue) => {

        let apiSyllabus = ApiCalls.getSyllabus(this.state.productId.value, newValue.value);
        let dataSyllabus;
        apiSyllabus.then((data) =>{
            dataSyllabus = data.LessonModifierRequestModel.LessonDetailModel.Description;
        }).then(()=> {
            // Then, set the state
            this.setState({
                syllabusInfo: dataSyllabus
            });
        });
    };

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        this.setState({navbarMobile: window.screen.width <= 1024});
    }

    // Call the item list
    render() {
        return (
            <div>
                {this.state.navbarMobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding">
                    <Container className="margin-top-mandatory-60">
                        <h2 className="font-now-bold white-text">
                            <FontAwesomeIcon icon={faList}/>{' '}
                            <Translate id="dashboard.syllabus" options={{renderInnerHtml: true}}/>
                        </h2>
                        <hr/>
                        <Col sm={{size: 12, offset: 0}} lg={{size: 12, offset: 0}}>
                            <Card className="card">
                                <CardHeader className="card-darker-transparency">
                                    <h4 className="white-text">
                                        <Translate id="syllabus.lesson-syllabus" options={{renderInnerHtml: true}}/>
                                    </h4>
                                    <small className="white-text">
                                        <Translate id="syllabus.instructions" options={{renderInnerHtml: true}}/>
                                    </small>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col sm={{size: 12}} md={{size: 4}} lg={{size: 3}}>
                                            <p><b><Translate id="syllabus.select-class"
                                                             options={{renderInnerHtml: true}}/></b></p>
                                            <SelectorProduct updateParent={this.callLessons()}/>
                                        </Col>
                                        <Col sm={{size: 12}} md={{size: 8}} lg={{size: 9}}>
                                            <p><b><Translate id="syllabus.select-lesson"
                                                             options={{renderInnerHtml: true}}/></b></p>
                                            { this.state.productId !== null ?
                                                <SelectorLesson data={this.state}
                                                                updateParent={this.callSyllabus()}/> : null }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <hr/>
                                            <div className="margin-top-mandatory-60 container-padding">
                                                { this.state.syllabusInfo != null ?
                                                    <div
                                                        dangerouslySetInnerHTML={{__html: (this.state.syllabusInfo)}}/> : null }
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Container>
                </div>
                <Footer/>
            </div>
        )
    };
}

export default withLocalize(Syllabus);